import React, { useEffect, useRef } from 'react';
import { useMutation } from 'react-query';
import { AlertModal } from '@raptormaps/alert-modal';
import { useToast } from '@raptormaps/toast';
import { getRemoveOrgAccessToFarmMutation } from '../../../api/services/farm-orgs';

interface RemoveOrgAccessToFarmProps {
  solarFarmOrgId: number;
  solarFarmId: number;
  orgName: string;
  permissionId: number;
  onClose: () => void;
}

export const RemoveOrgAccessToFarm = ({
  solarFarmId,
  solarFarmOrgId,
  permissionId,
  orgName,
  onClose,
}: RemoveOrgAccessToFarmProps) => {
  const alertModalTriggerRef = useRef<() => void>(() => null);
  const toast = useToast();

  useEffect(() => {
    alertModalTriggerRef.current();
  }, []);

  const { mutateAsync: removeOrgAccessToFarm } = useMutation(
    getRemoveOrgAccessToFarmMutation(solarFarmId, solarFarmOrgId, permissionId),
  );

  const handleConfirm = () => {
    toast.promise(
      removeOrgAccessToFarm().then(() => onClose()),
      {
        loading: 'Removing org access to farm...',
        error: 'Unable to remove org access to the farm. Please try again.',
        success: 'Org access to farm has been removed!',
      },
    );
  };

  return (
    <AlertModal
      title={`Remove ${orgName}`}
      description={`All users within ${orgName} will no longer have access to this site.`}
      confirmBtnText="Remove"
      variant="error"
      onConfirm={() => handleConfirm()}
      onCancel={() => onClose()}
      triggerRef={alertModalTriggerRef}
    />
  );
};
